import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { useSnapshot } from "valtio";
import Preview from "./Preview";
import BannerImages from "../../Common/BannerImages";
import { templateActions, templateStore } from "../../templateStore";
import { useSelector } from "react-redux";

const BANNIER_MODELE_PATH = [
    "Application",
    "ChoixBoutique",
    "Default",
    "BannierModele",
];

const BANNIER_MODELE_1 = 0;
const BANNIER_MODELE_2 = 1;

const RADIO_LABEL_STYLE: React.CSSProperties = {
    cursor: "pointer",
    gap: "18px",
};

const RADIO_TEXT_STYLE: React.CSSProperties = {
    color: "#323333",
    fontWeight: "bold",
};

export function ShopSelection({ selectedRow }: any) {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const { template } = useSnapshot(templateStore);
    const bannierModele: number =
        template.Application.ChoixBoutique.Default.BannierModele ?? 0;

    const handleBannierModeleChange = React.useCallback((value: number) => {
        templateActions.updateTemplate(BANNIER_MODELE_PATH, value);
    }, []);

    const bannierImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", "Default", "BannierBoutique"],
        []
    );

    const logoImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", "Default", "LogoBoutique"],
        []
    );

    const tabs = [
        {
            title: t("Shop selection"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={bannierImagePath}
                                title="Image de la banniere"
                                size="(png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={logoImagePath}
                                title="Logo"
                                size="30*30 (png,jpg,jpeg ou webp)"
                            />
                            <div>
                                <div style={{ padding: "10px 10px" }}>
                                    <h6 className="section-text">
                                        {t("Shop display model")}
                                    </h6>
                                    <div className="d-flex flex-column mt-3 pl-4">
                                        <label
                                            className="d-flex align-items-center mb-3"
                                            style={RADIO_LABEL_STYLE}
                                        >
                                            <input
                                                type="radio"
                                                name="bannier-modele"
                                                value={BANNIER_MODELE_1}
                                                checked={
                                                    bannierModele ===
                                                    BANNIER_MODELE_1
                                                }
                                                onChange={() =>
                                                    handleBannierModeleChange(
                                                        BANNIER_MODELE_1
                                                    )
                                                }
                                                data-testid="shop-selection-bannier-modele-0-radio"
                                            />
                                            <span style={RADIO_TEXT_STYLE}>
                                                {t("Model 1")}
                                            </span>
                                        </label>
                                        <label
                                            className="d-flex align-items-center mb-3"
                                            style={RADIO_LABEL_STYLE}
                                        >
                                            <input
                                                type="radio"
                                                name="bannier-modele"
                                                value={BANNIER_MODELE_2}
                                                checked={
                                                    bannierModele ===
                                                    BANNIER_MODELE_2
                                                }
                                                onChange={() =>
                                                    handleBannierModeleChange(
                                                        BANNIER_MODELE_2
                                                    )
                                                }
                                                data-testid="shop-selection-bannier-modele-1-radio"
                                            />
                                            <span style={RADIO_TEXT_STYLE}>
                                                {t("Model 2")}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => {
                            return (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => toggleNav(index)}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview
                    shopData={{
                        shopName:
                            selectedRow[0].subRows[0].Boutique ??
                            selectedRow[0].subRows[0].Shop,
                        shopAdress:
                            selectedRow[0].subRows[0].Adresse ??
                            selectedRow[0].subRows[0].Address,
                    }}
                />
            </div>
        </div>
    );
}
